import { atom, useSetAtom } from 'jotai';
import { useCallback, useEffect, useRef } from 'react';

export const hoveredNodeIdAtom = atom<string | null>(null);

export function useSetHoveredNodeIdThrottled(): (value: string | null) => void {
  const setAtom = useSetAtom(hoveredNodeIdAtom);
  const rafRef = useRef<number | null>(null);
  const pendingRef = useRef<string | null>(null);

  useEffect(() => {
    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, []);

  return useCallback(
    (value: string | null) => {
      pendingRef.current = value;
      if (rafRef.current !== null) return;
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
        setAtom(pendingRef.current);
      });
    },
    [setAtom]
  );
}
